// extracted by mini-css-extract-plugin
export var attribution = "_bv-4";
export var authorName = "_bv-5";
export var quote = "_bv-3";
export var testimonial = "_bv-2";
export var trustedBy = "_bv-0";
export var trustedByLabel = "_bv-1";